export default function OptimizerBenefits() {
  const benefits = [
    {
      icon: 'ri-printer-line',
      title: '打印PDF',
      description: '处理包含嵌入内容和高分辨率图像、需要颜色转换和存在问题的透明度图层的臃肿文档。'
    },
    {
      icon: 'ri-smartphone-line',
      title: '移动设备',
      description: '创建适合移动端的文档,加载快速,在任何设备上都能保持一致的查看效果。'
    },
    {
      icon: 'ri-archive-line',
      title: '归档PDF',
      description: '为长期存储和检索归档文档,通常用于满足监管和合规要求。'
    },
    {
      icon: 'ri-file-reduce-line',
      title: '减小PDF文件大小',
      description: '在保持视觉质量和文档结构的同时压缩PDF,允许在需要时将内容恢复到原始状态。'
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-br from-gray-50 to-teal-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            开发者使用PDF Optimizer的场景
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            为各种应用场景提供专业的PDF优化解决方案
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {benefits.map((benefit, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100"
            >
              <div className="flex items-start gap-6">
                <div className="flex-shrink-0 w-14 h-14 bg-gradient-to-br from-teal-500 to-cyan-500 rounded-xl flex items-center justify-center shadow-lg">
                  <i className={`${benefit.icon} text-2xl text-white`}></i>
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-bold text-gray-900 mb-3">
                    {benefit.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {benefit.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
